import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as actions from '../../state/actions'
import { bindActionCreators } from 'redux'

class TransactionsContainer extends Component {
    render() {
        var self = this
        const childrenWithProps = React.Children.map(self.props.children,
            (child) => React.cloneElement(child, { paid: self.props.paid, pending: self.props.pending, rejected: self.props.rejected, saveup: self.props.saveup, created: self.props.created })
        )

        return (
            <div>
                { childrenWithProps }
            </div>
        )
    }
}

TransactionsContainer.propTypes = {
    paid: PropTypes.number,
    pending: PropTypes.number,
    rejected: PropTypes.number,
    saveup: PropTypes.number,
    created: PropTypes.number
}

function mapStateToProps(state) {
    return {
        app: state.app,
        routing: state.routing
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(TransactionsContainer)



// WEBPACK FOOTER //
// ./containers/TransactionsContainer/index.js